<template>
   <div class="emb-thankyou-wrap section-gap">
      <div class="container py-0">
         <div class="layout justify-center align-center">
            <v-flex sm12 md10 lg8 xl8>
               <div class="form-img thank-you-image text-center hidden-sm-and-down" :style="'background-image: url('+ thankSection.Banner_Image_800X400_px +');'">
                  <h2 class="white--text">{{thankSection.Thank_You_Label}}</h2>
               </div>
               <div class="layout align-center justify-center">
                  <v-flex xs12 md8 lg6 xl6>
                     <div 
                        class="emb-card pa-6
                           thankyou-block
                           white pa-6
                           text-center"
                     >
                        <h4 class="px-6 pb-2 text-center">{{thankSection.Content1}}</h4>
                        <v-divider class="pt-2 pb-4"></v-divider>
                        <div class="mx-auto text-center">
                           <p class="mb-4">{{thankSection.Content2}}</p>
                           <div class="mb-6 d-block"> 
                              <emb-social-share :socialIcons="thankSection">
                                
                              </emb-social-share>
                           </div>
                        </div>
                        <v-btn block class="accent elevation-5 my-0" height="50">{{thankSection.Buy_Button_Label}}</v-btn>
                     </div>
                  </v-flex>
               </div>
            </v-flex>
         </div>
      </div>
   </div>
</template>
<script>
import Vue from 'vue';
import gettingRestClientObject from "../../../services/utils/cms-helper" ;
import VueAlertify from 'vue-alertify';
Vue.use(VueAlertify);
	export default{
		data(){
			return{
				
				cmsRequestFunctions:'',
            thankSection:'',
            icons:[]
			}
			},
			mounted() {
	
	this.cmsRequestFunctions = gettingRestClientObject();
	this.getPageData();
  },
  methods: {
getPageData: function() {

var self=this;
var language = localStorage.Language? localStorage.Language : "en";

var config = {
pageType: "Template/",
pageUrl : "15 Thank You/15 Thank You/15 Thank You.ftl",
lang :language,

successCallback: function(response) {
var res = response.data;
if (res.area_List) {
			var thank = self.cmsRequestFunctions.pluck("Thanks_Section",res.area_List);
         self.thankSection = self.cmsRequestFunctions.getAllMapData(thank[0].component);
        

         
			}


},
errorCallback: function(error) {
console.log(error);
}
};
this.cmsRequestFunctions.cmsRequest(config,language);
},



  },
   
   
	};
</script>	